import { Helmet } from "react-helmet-async";
import { LEGAL_NAME, SOCIAL_PROFILES } from "../config/branding";

export default function SEO({
  title = "JisedAI | AI Engineering and Digital Products for Africa",
  description = "Jisedai Foundry Africa Ltd builds AI-powered products, automation, and technical systems for organisations across Africa.",
  image = "https://www.jisedai.africa/jisedai-logo.png",
  url = "https://www.jisedai.africa",
  type = "website",
}) {
  const organisationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://www.jisedai.africa/#organization",
    name: LEGAL_NAME,
    alternateName: ["JisedAI", "Jised-AI"],
    url: "https://www.jisedai.africa",
    logo: "https://www.jisedai.africa/jisedai-orbit-logo.png",
    sameAs: SOCIAL_PROFILES.map(({ url: profileUrl }) => profileUrl),
    description:
      "AI engineering, digital products, training, and intelligent systems for organisations across Africa.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "CPF House, Haile Selassie Avenue, 4th Floor",
      addressLocality: "Nairobi",
      addressCountry: "KE",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+254777748910",
      contactType: "customer support",
      areaServed: "Africa",
      availableLanguage: "English",
    },
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content="JisedAI, Jised-AI, Jisedai Foundry Africa, AI engineering Kenya, artificial intelligence Africa, business automation, digital products"
      />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta name="author" content={LEGAL_NAME} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="JisedAI" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <link rel="canonical" href={url} />
      <script type="application/ld+json">{JSON.stringify(organisationSchema)}</script>
    </Helmet>
  );
}
